import { checkMaterial } from '@/api/product'

// Cart items keep a one-time snapshot of their material/recipe stock status
// (taken when the item was added/edited). If admin settings change afterward,
// that snapshot goes stale and keeps blocking/unblocking based on old data.
// Call this whenever the cart/checkout page loads so validation always runs
// against a fresh snapshot instead of whatever was cached at add-to-cart time.
export async function refreshCartMaterials(cart) {
  if (!cart || !cart.item || cart.item.length === 0) {
    return cart
  }

  await Promise.all(cart.item.map(async(item) => {
    if (!item || !item.materials || item.materials.length === 0) {
      return
    }
    const objId = item.product_variant_id
      ? { product_variant_id: Number(item.product_variant_id) }
      : { product_id: Number(item.product_id) }
    try {
      const { data } = await checkMaterial(objId)
      item.materials = data.data.materials
    } catch (e) {
      // keep the existing snapshot if the refresh call fails (e.g. offline)
    }
  }))

  return cart
}

export function buildStockIndex(cart, skipIndex) {
  if (skipIndex === undefined) skipIndex = null

  var index = {
    product: {},
    variant: {}
  }

  if (!cart || !cart.item || cart.item.length === 0) {
    return index
  }

  cart.item.forEach(function(item, cartIndex) {
    // skip item yang sedang diedit
    if (skipIndex !== null && cartIndex === skipIndex) {
      return
    }

    var cartQty = Number(item.qty) || 0

    // ================= PRODUCT =================
    if (item.product_id) {
      index.product[item.product_id] =
        (index.product[item.product_id] || 0) + cartQty
    }

    // ================= VARIANT =================
    if (item.product_variant_id) {
      index.variant[item.product_variant_id] =
        (index.variant[item.product_variant_id] || 0) + cartQty
    }

    // ================= COMBO ITEMS =================
    if (item.product_combo_items && item.product_combo_items.length) {
      item.product_combo_items.forEach(function(combo) {
        var comboQty = cartQty * Number(combo.qty || 0)

        if (combo.id) {
          index.product[combo.id] =
            (index.product[combo.id] || 0) + comboQty
        }

        if (combo.variant_id) {
          index.variant[combo.variant_id] =
            (index.variant[combo.variant_id] || 0) + comboQty
        }

        // addons dalam combo
        if (combo.addons && combo.addons.length) {
          combo.addons.forEach(function(addon) {
            var addonQty = cartQty * Number(addon.product_addon_qty || 0)

            if (addon.product_addon_variant_id) {
              index.variant[addon.product_addon_variant_id] =
                (index.variant[addon.product_addon_variant_id] || 0) + addonQty
            }

            // TODO: hapus fallback product_addon_proudct_id setelah cart lama di localStorage expired (hapus dalam 2-3 hari setelah deploy)
            var addonProductId = addon.product_addon_product_id != null ? addon.product_addon_product_id : addon.product_addon_proudct_id
            if (addonProductId) {
              index.product[addonProductId] =
                (index.product[addonProductId] || 0) + addonQty
            }
          })
        }
      })
    }

    // ================= MATERIALS =================
    if (item.materials && item.materials.length) {
      item.materials.forEach(function(material) {
        if (material.material_product_variant_id) {
          index.variant[material.material_product_variant_id] =
            (index.variant[material.material_product_variant_id] || 0) +
            Number(material.qty_in_cart || 0)
        }

        if (material.material_product_id) {
          index.product[material.material_product_id] =
            (index.product[material.material_product_id] || 0) +
            Number(material.qty_in_cart || 0)
        }
      })
    }

    // ================= ADDONS =================
    if (item.addons && item.addons.length) {
      item.addons.forEach(function(addon) {
        var addonQty = cartQty * Number(addon.product_addon_qty || 0)

        if (addon.product_addon_variant_id) {
          index.variant[addon.product_addon_variant_id] =
            (index.variant[addon.product_addon_variant_id] || 0) + addonQty
        }

        // TODO: hapus fallback product_addon_proudct_id setelah cart lama di localStorage expired (hapus dalam 2-3 hari setelah deploy)
        var addonProductId = addon.product_addon_product_id != null ? addon.product_addon_product_id : addon.product_addon_proudct_id
        if (addonProductId) {
          index.product[addonProductId] =
            (index.product[addonProductId] || 0) + addonQty
        }
      })
    }
  })
  return index
}
